import { Component, ChangeDetectionStrategy } from '@angular/core';

import { AddressBaseComponent } from '@ups/xplat/features';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-address',
  templateUrl: 'address.component.html',
  standalone: false,
})
export class AddressComponent extends AddressBaseComponent {
  constructor() {
    super();
  }
}
